import { render, staticRenderFns } from "./ValidationCell.vue?vue&type=template&id=cf08b74c&scoped=true&"
import script from "./ValidationCell.vue?vue&type=script&lang=js&"
export * from "./ValidationCell.vue?vue&type=script&lang=js&"
import style0 from "./ValidationCell.vue?vue&type=style&index=0&id=cf08b74c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf08b74c",
  null
  
)

export default component.exports